export const youtube = {
  name: 'Youtube',
  id: 'youtube',
  url: 'https://www.youtube.com/',
  color: '#eb3223',
  compatible: true
}
